/**
 * Is `true` when `window` is undefined, including server rendering, Workers, and Node. `Reflect.get` keeps the package
 * free of DOM types and returns `true` when a test sets `window` to `undefined`, as `typeof window === 'undefined'`
 * did.
 */
export const isServer = Reflect.get(globalThis, 'window') === undefined
